import { readItems } from "@directus/sdk";
import directus from "@/lib/directus";
import { REACT_APP_PUBLIC_DIRECTUS_API, ReloadModel } from "@/constants";
import axios from "axios";

export const depositService = {

    fetchDepositHistory: async (
        phoneNumber: string,
    ): Promise<{
        success: boolean;
        error?: Error;
        depots?: ReloadModel[];
    } | undefined> => {
        try {

            const currentDate = new Date();

            const date30DaysAgo = new Date();
            date30DaysAgo.setDate(currentDate.getDate() - 30);

            const date30DaysAgoISO = date30DaysAgo.toISOString();
            const currentDateISO = currentDate.toISOString();

            const depostList = await directus.request(readItems("depot", {
                filter: {
                    numero_commercial: {
                        _eq: phoneNumber,
                    },
                    date_created: {
                        _gte: date30DaysAgoISO,
                        _lte: currentDateISO,
                    },
                },
                sort: ['-date_created'],
            }));
            const depotsListToReturn = depostList as ReloadModel[];

            return {
                success: true,
                depots: depotsListToReturn,
            };

        } catch (error: any) {
            return {
                success: false,
                error: new Error(error.message || "Erreur lors de la récupération des dépôts"),
            };
        }
    },

    fetchDepositHistoryForPaymentNumber: async (
        phoneNumber: string,
    ): Promise<{
        success: boolean;
        error?: Error;
        depots?: ReloadModel[];
    } | undefined> => {
        try {

            const currentDate = new Date();

            const date30DaysAgo = new Date();
            date30DaysAgo.setDate(currentDate.getDate() - 1);

            const date30DaysAgoISO = date30DaysAgo.toISOString();
            const currentDateISO = currentDate.toISOString();
            const response = await axios.get(REACT_APP_PUBLIC_DIRECTUS_API + '/items/depot', {
                params: {
                    filter: {
                        numero_initial: {
                            _eq: phoneNumber,
                        },
                        date_created: {
                            _gte: date30DaysAgoISO,
                            _lte: currentDateISO,
                        },
                    },
                    sort: '-date_created'
                }
            });

            const depotsListToReturn = response.data['data'] as any as ReloadModel[];

            return {
                success: true,
                depots: depotsListToReturn,
            };

        } catch (error: any) {
            console.log(JSON.stringify(error))
            return {
                success: false,
                depots: [],
                error: new Error(error.message || "Erreur lors de la récupération des dépôts"),
            };
        }
    },

    /**
     * Calcule le cumul des dépôts pour un client donné
     * Utilisé pour la validation des parrainages du concours
     */
    fetchCumulativeDeposits: async (
        clientId: string,
    ): Promise<{
        success: boolean;
        error?: Error;
        cumulativeDeposits?: number;
    }> => {
        try {
            const depots = await directus.request(readItems("depot", {
                filter: {
                    account_id: {
                        _eq: clientId,
                    },
                },
                fields: ["montant"],
            }));

            const cumulativeDeposits = depots.reduce((sum: number, depot: any) => sum + (depot.montant || 0), 0);

            return {
                success: true,
                cumulativeDeposits,
            };
        } catch (error: any) {
            return {
                success: false,
                error: new Error(error.message || "Erreur lors du calcul du cumul des dépôts"),
            };
        }
    },

};
